// https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
// https://tools.ietf.org/html/rfc6455#section-7.4.1

export let codes = {
    1000: {
        reason: 'Normal Closure',
        desc: 'Normal closure; the connection successfully completed whatever purpose for which it was created.',
        tips: ''
    },
    1001: {
        reason: 'Going Away',
        desc: 'The endpoint is going away, either because of a server failure or because the browser is navigating away from the page that opened the connection.',
        tips: ''
    },
    1002: {
        reason: 'Protocol Error',
        desc: 'The endpoint is terminating the connection due to a protocol error.',
        tips: ''
    },
    1003: {
        reason: 'Unsupported Data',
        desc: 'The connection is being terminated because the endpoint received data of a type it cannot accept (for example, a text-only endpoint received binary data).',
        tips: ''
    },
    1004: {
        reason: '',
        desc: 'Reserved. A meaning might be defined in the future.',
        tips: ''
    },
    1005: {
        reason: 'No Status Received',
        desc: 'Reserved.  Indicates that no status code was provided even though one was expected.',
        tips: ''
    },
    // 异常关闭比较常见
    1006: {
        reason: 'Abnormal Closure',
        desc: 'Reserved. Used to indicate that a connection was closed abnormally (that is, with no close frame being sent) when a status code is expected.',
        tips: ''
    },
    1007: {
        reason: 'Invalid frame payload data',
        desc: 'The endpoint is terminating the connection because a message was received that contained inconsistent data (e.g., non-UTF-8 data within a text message).',
        tips: ''
    },
    1008: {
        reason: 'Policy Violation',
        desc: 'The endpoint is terminating the connection because it received a message that violates its policy. This is a generic status code, used when codes 1003 and 1009 are not suitable.',
        tips: ''
    },
    1009: {
        reason: 'Message too big',
        desc: 'The endpoint is terminating the connection because a data frame was received that is too large.',
        tips: ''
    },
    1010: {
        reason: 'Missing Extension',
        desc: 'The client is terminating the connection because it expected the server to negotiate one or more extension, but the server didn\'t.',
        tips: ''
    },
    1011: {
        reason: 'Internal Error',
        desc: 'The server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.',
        tips: ''
    },
    1012: {
        reason: 'Service Restart',
        desc: 'The server is terminating the connection because it is restarting. [Ref]',
        tips: ''
    },
    1013: {
        reason: 'Try Again Later',
        desc: 'The server is terminating the connection due to a temporary condition, e.g. it is overloaded and is casting off some of its clients. [Ref]',
        tips: ''
    },
    1014: {
        reason: 'Bad Gateway',
        desc: 'The server was acting as a gateway or proxy and received an invalid response from the upstream server. This is similar to 502 HTTP Status Code.',
        tips: ''
    },
    1015: {
        reason: 'TLS Handshake',
        desc: 'Reserved. Indicates that the connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can\'t be verified).',
        tips: ''
    },
    4501: {
        reason: '服务内部的错误。',
        desc: '服务内部的错误。',
        tips: '联系管理员或者相关技术人员进行分析解决。'
    }
};